module.exports = __webpack_public_path__ + "img/support.14bac93d.svg";